<template>
  <div>
    <video autoplay muted loop id="blueVideo">
      <source src="https://tabbot-central.b-cdn.net/video/BlauerHintergrundPlatine.mp4" type="video/mp4">
    </video>
    <div class="blue-container">
      <Header currentTimer="" hideTimer="true" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col my-auto">
              <div class="row justify-content-center">
                <div class="col-4 text-center">
                  <div class="flag-de">Wähle deine bevorzugte Sprache</div>
                </div>
                <div class="col-1"></div>
                <div class="col-4 text-center">
                  <div class="flag-en">Choose your favorite language</div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-4 pt-3">
                  <div class="flag-de"><a @click="switchLocaleToDe"><img src="@/assets/flag_de.svg" alt="deutsch" /></a></div>
                </div>
                <div class="col-1"></div>
                <div class="col-4 pt-3">
                  <div class="flag-en"><a @click="switchLocaleToEn"><img src="@/assets/flag_en.svg" alt="english" /></a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Language',
  components: {
    Header, Footer
  },
  methods: {
    switchLocaleToDe: function () {
      this.$i18n.locale = 'de'
      this.$store.commit('languageSelected')
    },
    switchLocaleToEn: function () {
      this.$i18n.locale = 'en'
      this.$store.commit('languageSelected')
    }
  }
}
</script>
